import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getvendorHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "vendor", ...action.payload }),
		);
		yield put({
			type: types.GET_VENDOR_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_VENDOR_ERROR,
			payload,
		});
	}
}

export function* getvendorWatcherSaga() {
	yield takeLatest(types.GET_VENDOR_START, getvendorHandlerSaga);
}

//create

//delete

function* deletevendorHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("vendor", action.payload),
		);
		yield put({
			type: types.DELETE_VENDOR_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_VENDOR_ERROR,
			payload,
		});
	}
}

export function* deletevendorWatcherSaga() {
	yield takeLatest(types.DELETE_VENDOR_START, deletevendorHandlerSaga);
}

//update
